import { Variant } from '@kizi/core-components';

const accordion: Variant = {
  marginTop: '3px',
};

const regular: Variant = {
  fill: 'text',
  height: 24,
  width: 24,
  minWidth: 24,
};

const big: Variant = {
  fill: 'text',
  height: 28,
  width: 28,
  minWidth: 28,
};

const extraSmall: Variant = {
  fill: 'text',
  height: 12,
  width: 12,
  minWidth: 12,
};

const small: Variant = {
  fill: 'text',
  height: 16,
  width: 16,
  minWidth: 16,
};

const regularLight: Variant = {
  ...regular,
  fill: 'white',
};

const danger: Variant = {
  ...regular,
  fill: 'danger',
};

const dangerBig: Variant = {
  ...big,
  fill: 'danger',
};

const disabledLightBig: Variant = {
  ...big,
  fill: 'disabledLight',
};

const dangerExtraSmall: Variant = {
  ...extraSmall,
  fill: 'danger',
};

const iconLink: Variant = {
  fill: 'main.1',
  height: 18,
  width: 18,
  minWidth: 18,
};

const iconLinkDisabled: Variant = {
  fill: 'disabled',
  height: 18,
  width: 18,
  minWidth: 18,
};

const iconLinkError: Variant = {
  fill: 'error',
  height: 18,
  width: 18,
  minWidth: 18,
};

const infoExtraSmall = {
  ...extraSmall,
  fill: 'info',
};

const inputUnitPlaceholder: Variant = {
  ...regular,
  fill: 'placeholder',
  position: 'absolute',
  right: 2,
  top: 4,
};

const success: Variant = {
  ...regular,
  fill: 'success',
};

const successBig: Variant = {
  ...big,
  fill: 'success',
};

const successExtraSmall: Variant = {
  ...extraSmall,
  fill: 'success',
};

const successSmall: Variant = {
  ...small,
  fill: 'success',
};

const inputSuccess: Variant = {
  fill: 'success',
  height: 10,
  width: 10,
  position: 'absolute',
  right: 2,
  top: 4,
};

const warning: Variant = {
  ...regular,
  color: 'warning',
};

const warningBig: Variant = {
  ...big,
  color: 'warning',
};

const optionalBig: Variant = {
  ...big,
  fill: 'warning',
  color: 'warning',
};

const svgIcons = {
  accordion,
  danger,
  dangerBig,
  dangerExtraSmall,
  disabledLightBig,
  extraSmall,
  iconLink,
  iconLinkDisabled,
  iconLinkError,
  infoExtraSmall,
  inputUnitPlaceholder,
  regular,
  regularLight,
  small,
  success,
  successBig,
  successExtraSmall,
  successSmall,
  inputSuccess,
  warning,
  warningBig,
  optionalBig,
};

export default svgIcons;
